module.exports = __webpack_public_path__ + "img/clients2-717.b2fa632.png";